module.exports = __webpack_public_path__ + "img/main_banner.b0328e17.png";